/*global angular */
/*global sessionStorage */
/*global window */
/*global location */
/*global document */
/*jslint node: true */
'use strict';

var authExt = angular.module('msAuth', []);

function msAuthLogin(id, token, method) {
    if (!method) method = 'basic';
    var stuff = {type: method, id: id, token: token};
    sessionStorage.msAuthBasic = window.btoa(JSON.stringify(stuff));
}
window.msBasicAuth = msAuthLogin;

authExt.service('msUser', ['msAuth', '$rootScope', '$http', function (msAuth, $rootScope, $http) {
    function get_settings(on_success, on_error) {
        var data = msAuth.getAuth();
        $http.get('/api/users/' + data.type + '/' + data.id + '/settings', msAuth.request_auth_headers()).success(on_success).error(on_error || angular.noop);
        angular.extend();
    }

    function set_settings(settings, on_success, on_error) {
        var data = msAuth.getAuth();
        $http.put('/api/users/' + data.type + '/' + data.id + '/settings', settings, msAuth.request_auth_headers()).success(on_success).error(on_error || angular.noop);
    }

    var settings = {};
    var user = {};
    var last_update = null, initialized = false;

    function buffer(last) {
        setTimeout(function () {
            if (last == last_update) {
                set_settings(settings, function () {
                });
            }
        }, 1500);
    }

    $rootScope.user_settings = settings;
    $rootScope.$watch('user_settings', function () {
        var new_time = Date.now();
        if (last_update && initialized) {
            buffer(new_time);
        }
        last_update = new_time;
    }, true);

    $rootScope.$on('msAuthenticated', function () {
        angular.extend(user, $rootScope.userData);
        if ($rootScope.userData.settings) {
            angular.extend(settings, $rootScope.userData.settings);
            last_update = null;
            initialized = true;
        }
    });

    return {
        settings: settings,
        user: user
    };
}]);

authExt.service('msAuth', ['$timeout', '$rootScope', '$http', '$route', '$location', function ($timeout, $rootScope, $http, $route, $location) {

    var msAuthBasic = {
        getAuthorization: function () {
            return sessionStorage.msAuthBasic;
        },
        logout: function () {
            sessionStorage.msAuthBasic = ''; // TODO
        },
        getAuth: function () {
            return JSON.parse(window.atob(sessionStorage.msAuthBasic));
        }
    };

    $rootScope.userData = {
        admin: false,
        scopes: []
    };
    $rootScope.msAuth = msAuthBasic;

    function request_auth_headers() {
        return {
            headers: {
                'Authorization': sessionStorage.msAuthBasic,
                'X-Authorization': sessionStorage.msAuthBasic
            }
        };
    }

    /**
     * on_success fire msAuthenticated event
     * on_error redirect to login site /
     */
    var verifyAuthentication = function () {
        if (sessionStorage.msAuthBasic) {
            $http.get('/api/me', request_auth_headers()).success(function (data) {
                angular.extend($rootScope.userData, data);
                $rootScope.$broadcast('msAuthEvent');
            }).error(function () {
                window.location = '/';
            });

        } else if (location.hostname == 'localhost' || location.hostname == '192.168.10.118' || location.hostname == "127.0.0.1") {
            angular.extend($rootScope.userData, {name: 'local dummy', scopes: ['user']});
            msAuthLogin('admin', 'password', 'basic');
            setTimeout(function () {
                $rootScope.$broadcast('msAuthEvent');
            }, 16);
        } else {
            window.location = '/';
        }
    };

    $rootScope.$on('msAuthEvent', function () {
        if ($route.current && $route.current.$$route && $route.current.$$route.auth) {
            var auth = $route.current && $route.current.$$route && $route.current.$$route.auth;
            for (var i = 0; i < auth.scopes.length; i++) {
                if ($rootScope.userData.scopes.indexOf(auth.scopes[i]) == -1) {
                    if (auth.redirect) {
                        $location.path('redirect');
                    } else {
                        window.location = '/';
                    }
                    return;
                }
            }
        }
        $rootScope.$broadcast('msAuthenticated', $rootScope.userData);
    });

    $rootScope.$on('$locationChangeSuccess', verifyAuthentication);
    verifyAuthentication();

    return {
        request_auth_headers: request_auth_headers,
        getAuth: function () {
            return $rootScope.msAuth.getAuth();
        },
        getUserData: function () {
            return $rootScope.userData;
        }
    };
}])
;
